import * as React from 'react';
import { AppBar, Box, Toolbar, Typography, Link } from '@mui/material';
import { NavMenu } from './nav-menu';
import { HeaderSearch } from './header-search';
import { UserMenu } from './user-menu';
import { HelpMenu } from './help-menu';
import { HeaderMenu } from './header-menu';
import { EmptyHeader } from './empty-header';
import { HeaderMenuSmall } from './header-menu-small';
import { AppContext, Links } from '../../model';
import { CvIcon } from '../../icons';
import { SearchResult } from '../../model/common-types';
import { AppLoader } from '../loader/app-loader';

export interface HeaderProps {
  context?: AppContext;
  links?: Links;
  searchPlaceholder?: string;
  handleSearch?: (search: string) => Promise<SearchResult[]>;
}

export const Header = (props: HeaderProps) => {
  const { context, links, handleSearch, searchPlaceholder } = props;
  const [loading, setLoading] = React.useState(false);

  const onLoading = (isLoading: boolean) => {
    if (isLoading) {
      setTimeout(function () {
        setLoading(true);
      }, 1000);
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Box component="div" sx={{ flexGrow: 1 }}>
        <AppBar color="default">
          <Toolbar>
            {!!links?.nav?.length && <NavMenu context={context} links={links?.nav} onLoading={onLoading} />}
            <Box sx={{ mx: 1 }}>
              <Link href="/" color="inherit">
                <CvIcon sx={{ fontSize: 38, verticalAlign: 'middle' }} />
              </Link>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              color="inherit"
              sx={{ display: { xs: 'none', md: 'block' } }}
            >
              Classic Vacations
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <HeaderSearch
              searchUrl={links?.search}
              onLoading={onLoading}
              placeholder={searchPlaceholder}
              handleSearch={handleSearch ?? (async () => [] as SearchResult[])}
              showSearchMore={true}
            />
            <HelpMenu onLoading={onLoading} phone={context?.phone} links={links?.help} />
            <HeaderMenuSmall
              onLoading={onLoading}
              sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
              links={links?.main}
            />
            <UserMenu {...props} onLoading={onLoading} />
          </Toolbar>
          <Toolbar sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <Box>
              <HeaderMenu links={links?.main} />
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      {/* This is so that content will appear below the app bar */}
      <EmptyHeader />
      {/* single app loader for any header link */}
      {loading && <AppLoader open={loading} />}
    </>
  );
};
